import * as Cesium from 'cesium';
export const VECTOR_LAYER_TAG = '_landscape_vector_layer';
// Ground-polyline draw order for contour-highlight overlays: keeps the
// coloured slice above the base contour line it traces. Only applies while
// polylines are clamped to ground (3D terrain on).
export const CONTOUR_HIGHLIGHT_ZINDEX = 100;
export const isTerrainOn = (viewer) => {
    return !!viewer.scene.globe.depthTestAgainstTerrain;
};
export const applyTerrainModeToEntity = (entity, terrainOn) => {
    if (entity.polyline) {
        if (terrainOn) {
            entity.polyline.clampToGround = true;
            entity.polyline.arcType = Cesium.ArcType.GEODESIC;
        }
        else {
            entity.polyline.clampToGround = false;
        }
    }
    if (entity.polygon) {
        if (terrainOn) {
            entity.polygon.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
            entity.polygon.perPositionHeight = false;
        }
        else {
            entity.polygon.heightReference = Cesium.HeightReference.NONE;
        }
    }
};
export const applyTerrainModeToDataSource = (ds, terrainOn) => {
    if (!ds || !ds.entities || !ds.entities.values)
        return;
    for (const entity of ds.entities.values) {
        applyTerrainModeToEntity(entity, terrainOn);
    }
};
export const applyTerrainModeToAllVectorLayers = (viewer, terrainOn) => {
    var _a;
    const sources = viewer.dataSources;
    for (let i = 0; i < sources.length; i++) {
        const ds = sources.get(i);
        if (!ds)
            continue;
        if (ds[VECTOR_LAYER_TAG]) {
            applyTerrainModeToDataSource(ds, terrainOn);
        }
        else if ((_a = ds.entities) === null || _a === void 0 ? void 0 : _a.values) {
            // Mixed data sources (e.g. saved user artifacts) opt in per entity.
            for (const entity of ds.entities.values) {
                if (entity[VECTOR_LAYER_TAG]) {
                    applyTerrainModeToEntity(entity, terrainOn);
                }
            }
        }
    }
};
